// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const inp = {
  width: '100%', background: C.bg, border: `1px solid ${C.border}`,
  borderRadius: '8px', padding: '10px 14px', fontSize: '16px',
  fontFamily: f, color: C.brown, boxSizing: 'border-box', outline: 'none',
  marginBottom: '14px', WebkitUserSelect: 'text', userSelect: 'text',
  touchAction: 'manipulation', WebkitAppearance: 'none',
}
const lbl = {
  fontSize: '10px', color: C.muted, letterSpacing: '1.5px',
  textTransform: 'uppercase', fontFamily: fs, display: 'block', marginBottom: '5px',
}

const ROOM_TYPES = [
  ['bedroom', 'Bedroom'], ['bathroom', 'Bathroom'], ['kitchen', 'Kitchen'],
  ['living', 'Living Room'], ['dining', 'Dining Room'], ['garage', 'Garage'],
  ['office', 'Office'], ['den', 'Den'], ['pantry', 'Pantry'],
  ['closet', 'Closet'], ['hallway', 'Hallway'], ['other', 'Other'],
]

const FLOOR_OPTIONS = [
  { value: 0, label: 'Basement' },
  { value: 1, label: '1st Floor' },
  { value: 2, label: '2nd Floor' },
  { value: 3, label: '3rd Floor' },
  { value: 4, label: '4th Floor' },
  { value: 5, label: 'Attic' },
  { value: 99, label: 'Other' },
]

export default function AddRoom({ homeId, onSave, onClose }) {
  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [floorLevel, setFloorLevel] = useState(1)
  const [floorOther, setFloorOther] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    if (!name.trim()) return
    setSaving(true)
    const { data, error } = await supabase.from('rooms').insert({
      home_id: homeId,
      name: name.trim(),
      type: type || null,
      floor_level: floorLevel,
      room_notes: floorLevel === 99 && floorOther.trim() ? `Floor: ${floorOther.trim()}` : null,
    }).select().single()
    setSaving(false)
    if (!error && data) onSave(data)
  }

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.55)', zIndex: 1100, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div style={{ width: '100%', maxWidth: '480px', background: C.card, borderRadius: '20px 20px 0 0', border: `1px solid ${C.border}`, borderBottom: 'none', boxShadow: '0 -8px 40px rgba(44,29,20,0.2)', padding: '24px 24px 40px', fontFamily: f }}>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
          <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: C.border }} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '22px' }}>
          <div style={{ fontSize: '18px', fontWeight: '700', color: C.brown }}>Add Room</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: C.muted, padding: 0, lineHeight: 1 }}>×</button>
        </div>

        <label style={lbl}>Room Name</label>
        <input
          style={inp}
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="e.g. Master Bedroom, Downstairs Bath"
          autoFocus
        />

        <label style={lbl}>Room Type</label>
        <select style={{ ...inp, appearance: 'none', WebkitAppearance: 'none', cursor: 'pointer' }} value={type} onChange={e => setType(e.target.value)}>
          <option value="">Select type...</option>
          {ROOM_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>

        <label style={lbl}>Floor Level</label>
        <select style={{ ...inp, appearance: 'none', WebkitAppearance: 'none', cursor: 'pointer', marginBottom: floorLevel === 99 ? '8px' : '14px' }} value={floorLevel} onChange={e => setFloorLevel(parseInt(e.target.value))}>
          {FLOOR_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>

        {floorLevel === 99 && (
          <input
            style={inp}
            value={floorOther}
            onChange={e => setFloorOther(e.target.value)}
            placeholder="e.g. Mezzanine, Split level, Loft…"
          />
        )}

        <button
          onClick={handleSave}
          disabled={saving || !name.trim()}
          style={{ width: '100%', background: saving || !name.trim() ? C.border : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`, border: 'none', borderRadius: '10px', padding: '14px', color: saving || !name.trim() ? C.muted : C.card, fontSize: '14px', fontWeight: '700', cursor: saving || !name.trim() ? 'not-allowed' : 'pointer', fontFamily: f, letterSpacing: '1px', textTransform: 'uppercase' }}
        >{saving ? 'Adding...' : 'Add Room'}</button>
      </div>
    </div>
  )
}
